// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3l_FT","notes":"Notes_notes__2L5dv"};